var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99994 16.75C7.58994 16.75 7.24994 16.41 7.24994 16V11.81L6.52994 12.53C6.23994 12.82 5.75994 12.82 5.46994 12.53C5.17994 12.24 5.17994 11.76 5.46994 11.47L7.46994 9.46999C7.67994 9.25999 8.00994 9.18999 8.28994 9.30999C8.56994 9.41999 8.74994 9.69999 8.74994 9.99999V16C8.74994 16.41 8.40994 16.75 7.99994 16.75Z",
    fill: "#713FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99994 12.7499C9.80994 12.7499 9.61994 12.6799 9.46994 12.5299L7.46994 10.5299C7.17994 10.2399 7.17994 9.75994 7.46994 9.46994C7.75994 9.17994 8.23994 9.17994 8.52994 9.46994L10.5299 11.4699C10.8199 11.7599 10.8199 12.2399 10.5299 12.5299C10.3799 12.6799 10.1899 12.7499 9.99994 12.7499Z",
    fill: "#713FFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 21.75H8C2.57 21.75 0.25 19.43 0.25 14V8C0.25 2.57 2.57 0.25 8 0.25H13C13.41 0.25 13.75 0.59 13.75 1C13.75 1.41 13.41 1.75 13 1.75H8C3.39 1.75 1.75 3.39 1.75 8V14C1.75 18.61 3.39 20.25 8 20.25H14C18.61 20.25 20.25 18.61 20.25 14V9C20.25 8.59 20.59 8.25 21 8.25C21.41 8.25 21.75 8.59 21.75 9V14C21.75 19.43 19.43 21.75 14 21.75Z",
    fill: "#713FFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 9.74999H17C13.58 9.74999 12.25 8.41999 12.25 4.99999V0.999989C12.25 0.699989 12.43 0.419989 12.71 0.309989C12.99 0.189989 13.31 0.259989 13.53 0.469989L21.53 8.46999C21.74 8.67999 21.81 9.00999 21.69 9.28999C21.57 9.56999 21.3 9.74999 21 9.74999ZM13.75 2.80999V4.99999C13.75 7.57999 14.42 8.24999 17 8.24999H19.19L13.75 2.80999Z",
    fill: "#713FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile2);
export default __webpack_public_path__ + "static/media/file_2.0eca45cf.svg";
export { ForwardRef as ReactComponent };